module.exports = __webpack_public_path__ + "img/step33_a_printer_power_uncover_printer - Copy.ab64b23a.png";